import {
  DELETE_PROFILE_PIC_SUCCESS,
  DELETE_PROFILE_PIC_FAILED,
  RESET_DELETE_PROFILE_PIC,
  LOADING_DELETE_PROFILE_PIC
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETE_PROFILE_PIC:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        data: {}
      };
    case DELETE_PROFILE_PIC_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        data: action.payload
      };

    case DELETE_PROFILE_PIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        data: action.payload.data
      };

    case RESET_DELETE_PROFILE_PIC:
      return (state = initialState);

    default:
      return state;
  }
};
